import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPartyCelebrate = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 30L15 15L25 25L10 30Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 13L19 10",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27 22L30 21",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 13C24.6044 13 24.2178 12.8827 23.8889 12.6629C23.56 12.4432 23.3036 12.1308 23.1522 11.7654C23.0009 11.3999 22.9613 10.9978 23.0384 10.6098C23.1156 10.2219 23.3061 9.86549 23.5858 9.58579C23.8655 9.30608 24.2219 9.1156 24.6098 9.03843C24.9978 8.96126 25.3999 9.00087 25.7654 9.15224C26.1308 9.30362 26.4432 9.55996 26.6629 9.88886C26.8827 10.2178 27 10.6044 27 11C27 11.5304 26.7893 12.0391 26.4142 12.4142C26.0391 12.7893 25.5304 13 25 13Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 11C31 12.5913 30.3679 14.1174 29.2426 15.2426C28.1174 16.3679 26.5913 17 25 17",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.762 21.714L14.972 28.343",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.786 15.786L19.471 26.843",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgPartyCelebrate);
export default ForwardRef;
